import { useEffect, useState } from "react";
import { http } from "../../lib/api";
import Login from "./Login";
import Admin from "./Admin";

export default function AdminRoute() {
  const [user, setUser] = useState(undefined);
  useEffect(() => { http.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null)); }, []);
  const logout = async () => { await http.post("/auth/logout", {}).catch(() => {}); setUser(null); };
  if (user === undefined) return <div className="admin-loading" data-testid="admin-loading">Loading console…</div>;
  return user ? <Admin user={user} onLogout={logout} /> : <Login onLogin={setUser} />;
}
